import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  prefetchLikelyRoutes,
  setupIntentRoutePrefetch,
} from "../../utils/routePrefetch";

function scheduleIdle(callback) {
  if (typeof window === "undefined") return () => {};
  if (typeof window.requestIdleCallback === "function") {
    const id = window.requestIdleCallback(callback, { timeout: 5000 });
    return () => window.cancelIdleCallback?.(id);
  }
  const id = window.setTimeout(callback, 3000);
  return () => window.clearTimeout(id);
}

export default function NavigationWarmup() {
  const location = useLocation();

  useEffect(() => setupIntentRoutePrefetch(document), []);

  useEffect(
    () => scheduleIdle(() => prefetchLikelyRoutes(location.pathname)),
    [location.pathname],
  );

  return null;
}
